﻿import $ from 'jquery';
import _ from 'underscore';

declare global {
  interface JQuery {
    drawer: (option, args) => any;
  }
}
// todo: multiple drawers?
// todo: detect orientation change and close.

export class Drawer {
  public static get wireup(): string {
    return '[data-drawer]';
  }

  private $drawer: JQuery;
  private get isOpen(): boolean {
    return this.$drawer.data('rustig.drawer.isOpen') === true;
  }
  private set isOpen(value: boolean) {
    this.$drawer.data('rustig.drawer.isOpen', value);
  }
  private get isClosed(): boolean {
    return !this.isOpen;
  }
  private get $overlay(): JQuery {
    return $('[data-drawer-overlay]');
  }

  constructor(private $toggle: JQuery/*, options: any */) {
    let targetId = $toggle.data('drawer');
    if (!targetId)
      throw new Error('drawer needs a target!');

    _.once(() => this.wireup())();

    this.$drawer = $('[data-drawer-content=\"' + targetId + '\"]');

    this.addCssFooterStateIfNeeded();
    this.$drawer.data('rustig.drawer.isOpen', false);
  }

  public toggle() {
    if (this.isOpen)
      this.close();
    else
      this.open();
  }

  public open() {
    if (this.isOpen)
      return;

    this.$drawer.addClass('d-open');
    this.$overlay.addClass('d-show');

    this.isOpen = true;
    this.$drawer.data('rustig.drawer.isOpen', true);
  }

  public close() {
    if (this.isClosed)
      return;

    this.$drawer.removeClass('d-open');
    this.$overlay.removeClass('d-show');

    this.isOpen = false;
    this.$drawer.data('rustig.drawer.isOpen', false);
  }

  private addCssFooterStateIfNeeded() {
    var hasFooter = this.$drawer.find('.d-footer').length > 0;
    if (hasFooter)
      this.$drawer.find('.d-body').addClass('d-with-footer');
  }

  public static closeAll(): void {
    $('[data-drawer]').each(function () {
      $(this).data('rustig.drawer').close();
    });
  }

  private wireup() {
    $(document).on('click.rustig.drawer', Drawer.wireup, function () {
      $(this).data('rustig.drawer').toggle();
    });
    $(document).on('click.rustig.drawer', '[data-drawer-dismiss]', Drawer.closeAll);
  }
}

function Plugin(option, args) {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.drawer');
    let options = typeof option == 'object' && option;

    if (!data) {
      data = new Drawer($this/*, options*/);
      $this.data('rustig.drawer', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.drawer = Plugin;

export default Drawer;